import {
    apiRequest,
    employeeWFHDetail,
    employeeWFHReport,
    employeeWFHReportSend,
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class ReportRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeWFHDetail, {
            params: query
        }, true)
    }

    fetchReport = async (query) => {
        return await apiRequest("post", employeeWFHReport, {
            body: query
        }, true)
    }

    fetchReportSend = async (query) => {
        return await apiRequest("post", employeeWFHReportSend, {
            body: query
        }, true)
    }
}

export default ReportRepository